import { post } from "../../api";
import { authHeader } from "../../utils";

const getCartDetails = body => post("checkout", authHeader(), body);
const getStoresDetails = body => post("checkoutStores", authHeader(), body);
const getPaymentDetails = null;

export { getCartDetails, getPaymentDetails, getStoresDetails };



// WEBPACK FOOTER //
// ./src/stores/CheckoutStore/service.js